var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context";
import { GALLERY_TYPE } from "../types";
import { GalleryViewer } from "./gallery-viewer";
const Gallery = ({ node, nodeIndex, NodeViewContainer }) => {
  const { relValue, anchorTarget, config, seoMode, helpers } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    GalleryViewer,
    {
      componentData: node.galleryData || {},
      nodeId: node.id,
      settings: config[GALLERY_TYPE],
      relValue,
      anchorTarget,
      seoMode,
      helpers
    }
  ));
};
const GalleryRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(Gallery, __spreadValues({ key: node.id, node }, props));
};
var gallery_default = GalleryRenderer;
export {
  gallery_default as default
};
//# sourceMappingURL=gallery.js.map

import "@wix/ricos/css/plugin-gallery-viewer.global.css";